import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  let isLoggedIn = Boolean(localStorage.getItem("token"));

  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
